import { z } from "zod";

import { UUID } from "../generic/uuid.ts";

export const AgentStepStatus = z.enum(["pending", "running", "done", "error"]);
export type AgentStepStatus = z.infer<typeof AgentStepStatus>;

export const AgentStepPayload = z.object({
  id: z.string(),
  requestMessageId: UUID,
  sequence: z.number(),
  label: z.string(),
  status: AgentStepStatus,
  parentId: z.string().optional(),
  /** Retract a step already on screen: the call was rejected and retried. */
  dropped: z.boolean().optional(),
});
export type AgentStepPayload = z.infer<typeof AgentStepPayload>;
